import React, { useEffect, useState } from 'react';
import './estilos.css';
import Accordion from 'react-bootstrap/Accordion';
import { donativosRecibidos } from '../../json/donativosRecibidos';

  const DocumentosInteres = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
        <div className="row">
          <div className="row-content">
               <div className='ldf_titulo'>
                  <h2>Documentos de Interes</h2>
                  <hr className='hr-gob'/>
               </div>


               <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>DONATIVOS RECIBIDOS</Accordion.Header>
                      <Accordion.Body>
                        <Accordion>
                           {
                            donativosRecibidos.map((item, index)=>(
                            <Accordion.Item key={ index } eventKey= { item.eventoKey }>
                              <Accordion.Header> { item.tipoDonante }</Accordion.Header>
                              <Accordion.Body>
                                <table className="table table-striped table-bordered">
                                      <tbody>
                                       
                                         {
                                          item.donantes.map((item2, i)=>(
                                            <tr key={ i }>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td scope="row"><div> { item2.donante } </div></td>
                                                <td>
                                                  <div>
                                                      <a href={ item2.enlace } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                                  </div>
                                                </td>
                                            </tr>
                                          ))
                                         }

                                    </tbody>
                                </table>
                              </Accordion.Body>
                            </Accordion.Item>
                            ))
                          }
                        </Accordion>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header className="etiqueta">PROTOCOLO CERO</Accordion.Header>
                      <Accordion.Body>
                           <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                              <tbody>
                                <tr>
                                  <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                  <td style={{ textAlign: "left" }}>Protocolo Cero</td>
                                  <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/PROTOCOLOCERO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                  </td>
                                </tr>
                                
                                <tr>
                                    <td colspan="3"><p>Periodo 2023 - 2025</p></td>
                                </tr>
                                <tr>
                                  <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                  <td style={{ textAlign: "left" }}>Directorio de Personas Consejeras</td>
                                  <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/2023-2025/Directorio_de_Personas_Consejeras_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                  <td style={{ textAlign: "left" }}>Acuerdo de Personas Consejeras</td>
                                  <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/2023-2025/ACUERDO_PERSONAS_CONSEJERAS_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                  <td style={{ textAlign: "left" }}>Pronunciamiento</td>
                                  <td>
                                    <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/2023-2025/PRONUNCIAMIENTO_PROTOCOLO_CERO_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                    </div>
                                  </td>
                                </tr>
                                
                                <tr>
                                    <td colspan="3"><p>Periodo 2020 - 2022</p></td>
                                </tr>
                                <tr>
                                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                    <td style={{ textAlign: "left" }}>Directorio de Personas Consejeras</td>
                                    <td>
                                      <div>
                                          <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/2020-2022/Directorio_de_personas_consejeras.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                    <td style={{ textAlign: "left" }}>Acuerdo de Personas Consejeras</td>
                                    <td>
                                      <div>
                                          <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/2020-2022/AcuerdoPersonasConsejeras.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                    <td style={{ textAlign: "left" }}>Informe Anual 2020</td>
                                    <td>
                                      <div>
                                          <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/2020-2022/InformeAnual2020.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                    <td style={{ textAlign: "left" }}>Informe Anual 2021</td>
                                    <td>
                                      <div>
                                          <a href="http://dif.hidalgo.gob.mx/pdf/ProtocoloCero/2020-2022/InformeProtocoloCeroSistemaDIFHidalgo2021.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                      </div>
                                    </td>
                                  </tr>
                            </tbody>
                          </table>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header className="etiqueta">SISTEMA DE INFORMACIÓN DE CONTRALORIA SOCIAL (SICS)</Accordion.Header>
                      <Accordion.Body>
                        <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                        <tbody>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Esquema de Trabajo</td>
                            <td>
                              <div>
                                  <a href="http://dif.hidalgo.gob.mx/pdf/sics/EsquemaContraloriaSocial.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Guía Operativa</td>
                            <td>
                              <div>
                                  <a href="http://dif.hidalgo.gob.mx/pdf/sics/GuiaOperativaContraloriaSocial.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Programa Anual de Trabajo</td>
                            <td>
                              <div>
                                  <a href="http://dif.hidalgo.gob.mx/pdf/sics/ProgramaAnualTrabajoPATCS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Tríptico</td>
                            <td>
                              <div>
                                  <a href="http://dif.hidalgo.gob.mx/pdf/sics/TripticoCS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                      </tbody>
                    </table>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                      <Accordion.Header className="etiqueta">CONVENIOS DE COLABORACIÓN</Accordion.Header>
                      <Accordion.Body>
                        <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                        <tbody>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio CAI Bomberos</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_CAI_BOMBEROS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio CAI Colonias del Sur</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_CAI_SUR.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio CAI Matilde</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_CAI_MATILDE.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio Migrantes CD. Sahagún</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_MIGRANTES_CD_SAHAGUN.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio Migrantes Huejutla de Reyes</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_MIGRANTES_HUEJUTLA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio Migrantes Pachuca de Soto</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_MIGRANTES_PACHUCA_DE_SOTO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio Migrantes Tepeji del Río</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_MIGRANTES_TEPEJI_DEL_RIO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                            <td style={{ textAlign: "left" }}>Convenio PILARES Centro de Salud Mental</td>
                            <td>
                              <div>
                                 <a href="http://dif.hidalgo.gob.mx/pdf/CONVENIO_PILARES_CENTRO_DE_SALUD_MENTAL.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                              </div>
                            </td>
                          </tr>
                      </tbody>
                    </table>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

          </div>
        </div>
    </div>

    )
}

  export default DocumentosInteres
